<mat-select [(value)]="selectedVisibility" (selectionChange)="selected()">
  <mat-option *ngFor="let visibility of ['visible', 'notvisible', 'anonymous']" [value]="visibility">
    {{ 'VISIBILITY.' + visibility.toUpperCase() | translate }}
  </mat-option>
</mat-select>
  